{
  "version": 1,
  "asset_id": "c8ca4453-dbb3-4be6-a4bd-e3ba00ac9980",
  "project_id": "115256dd-a6cc-4bc1-95c1-d787d4c0e481",
  "url": "/__l5e/assets-v1/c8ca4453-dbb3-4be6-a4bd-e3ba00ac9980/lpgas-thumb.webp",
  "r2_key": "a/v1/115256dd-a6cc-4bc1-95c1-d787d4c0e481/c8ca4453-dbb3-4be6-a4bd-e3ba00ac9980/lpgas-thumb.webp",
  "original_filename": "lpgas-thumb.webp",
  "size": 4614,
  "content_type": "image/webp",
  "created_at": "2026-06-27T00:31:00Z"
}
